import { makeStyles } from "@material-ui/styles";
import { colors } from "styles/themeConfig";

export default makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: "1 0 auto",
    height: `calc(100vh - ${theme.mixins.toolbar.minHeight + theme.spacing(1)}px)`,
    position: "relative", //needed for topBg
  },
  topBg: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    height: 200,
    backgroundColor: colors.square_dark,
    backgroundSize: "cover",
    pointerEvents: "none",
  },
  container: {
    flex: 1,
    flexDirection: "column",
    height: "inherit",
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    zIndex: 2, //necessary
  },
  grow: {
    flex: 1,
    justifyContent: "flex-end",
    display: "flex",
  },
}));
